import App from './App.vue'
import { createVueRouter } from './router'
import { createApp as createCsrApp, createSSRApp } from 'vue'
import type { SSRContext } from '@/types/ssr/SSRContext.ts'
import { createI18n } from 'vue-i18n'
import nl from '@/lang/nl'
import en from '@/lang/en'
import { determineLocale } from '@/utils/determineLocale.ts'
import { HttpPlugin } from '@/plugins/http.ts'

export const createApp = (ssrContext?: SSRContext) => {
  const app = import.meta.env.SSR ? createSSRApp(App) : createCsrApp(App)
  const router = createVueRouter()

  const locale = determineLocale(ssrContext)

  const i18n = createI18n({
    locale: locale,
    fallbackLocale: 'en',
    legacy: false,
    messages: {
      nl,
      en,
    }
  })

  app.use(i18n)
  app.use(router)
  app.use(HttpPlugin)

  return {app, router}
}